import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Roles } from '../../../../constants';
import { areUserRolesIn } from '../../../../helpers';
import { cohortActions } from '../../../../store';

import type { RootState } from '../../../../store';

interface UseClientCohortAssignmentsParams {
  clientId: number | null;
  isEditable: boolean;
  getAccessTokenSilently: () => Promise<string>;
  userRoles: Roles[] | undefined;
}

export function useClientCohortAssignments({
  clientId,
  isEditable,
  getAccessTokenSilently,
  userRoles,
}: UseClientCohortAssignmentsParams) {
  const dispatch = useDispatch();
  const clientCohortAssignments = useSelector(
    (state: RootState) => state.cohorts.clientCohortAssignments,
  );
  const cohortAssignmentsLoading = useSelector((state: RootState) => state.cohorts.loading);

  useEffect(() => {
    if (clientId === null || !areUserRolesIn(userRoles ?? [], [Roles.Bcba])) {
      return;
    }

    void dispatch(
      cohortActions.getClientCohortAssignments({
        params: { client_id: clientId },
        getAccessTokenSilently,
      }),
    );
  }, [clientId, dispatch, getAccessTokenSilently, isEditable, userRoles]);

  return { clientCohortAssignments, cohortAssignmentsLoading };
}
